

var dispatcher = require("../dispatcher");

module.exports = {
    addVehicle:function(vehicle){
        dispatcher.dispatch({
            vehicle:vehicle,
            type:"vehicle:addVehicle"
        })
    },
    UpdateVehicle:function(vehicleInfo){
        dispatcher.dispatch({
            vehicleInfo:vehicleInfo,
            type:"vehicle:UpdateVehicle"
        })
    }
}





// WEBPACK FOOTER //
// ./src/actions/TransportAction.js